import React, { useCallback, useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import SortableTable from "../../Components/Table/SortableTable";
import { Button, Dialog, Grid } from "@material-ui/core";
import Signifier from "../../Components/Signifier";
import OutboundFeedTableCell from "../../Components/Table/OutboundTemplateableCell";
import OutboundFeedsTemplateModal from "../../Components/Modal/OutboundFeedsTemplateModal";
import { getAllOutboundFields, getOutboundTemplates } from "../../Services/API/OutboundTemplates";
import axios from "axios";

function OutboundFeedsTemplate() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "90%",
      marginBottom: "50px",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
    addButton: {
      marginTop: "25px",
      [theme.breakpoints.down("sm")]: {
        marginTop: "0px",
      },
    },
  }));

  const classes = useStyles();

  const [showSignifier, setShowSignifier] = useState(false);
  const [showError, setShowError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [data, setData] = useState([]);
  const [allFields, setAllFields] = useState([]);
  axios.defaults.headers.common["client"] = "";

  const columns = [
    { label: "Name", propName: "name" },
    { label: "Custom", propName: "customString" },
    { label: "Header Data", propName: "headerString" },
    { label: "Created", propName: "dateCreated" },
    { label: "Last Updated", propName: "dateLastUpdated" },
  ];

  const convertDate = (date) => {
    const newDate = new Date(date).toLocaleDateString("en-US");
    return newDate;
  };

  const loadTemplates = useCallback(() => {
    setLoading(true);
    setError(false);
    return getOutboundTemplates()
      .then((response) => {
        for (const i in response) {
          response[i].customString = response[i].isCustom ? "Yes" : "No";
          response[i].headerString = response[i].includeHeaderData ? "Yes" : "No";
          response[i].dateCreated = convertDate(response[i].dateCreated);
          response[i].dateLastUpdated = convertDate(response[i].dateLastUpdated);
        }
        return getAllOutboundFields().then((res) => {
          setData(response);
          setAllFields(res);
        });
      })
      .catch((err) => {
        console.error("Failed to load outbound templates:", err);
        setError(true);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    loadTemplates();
  }, [loadTemplates]);

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message="Template Added"
        error={showError}
      />
      <div className={classes.root}>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6}>
            <Button
              color="primary"
              className={classes.addButton}
              style={{ color: "white", marginBottom: "10px" }}
              type="submit"
              variant="contained"
              onClick={() => setOpenModal(true)}
            >
              Add Template
            </Button>
          </Grid>
        </Grid>
        <SortableTable
          columns={columns}
          tableData={data}
          loading={loading}
          error={error}
          onRetry={loadTemplates}
          rowComponent={OutboundFeedTableCell}
          defaultSortIndex={0}
        />
      </div>
      <Dialog open={openModal} fullWidth maxWidth="lg" onClose={() => setOpenModal(false)}>
        <OutboundFeedsTemplateModal
          openModal={setOpenModal}
          setData={setData}
          setShowSignifier={setShowSignifier}
          setShowError={setShowError}
          allFields={allFields}
        />
      </Dialog>
    </>
  );
}

export default OutboundFeedsTemplate;
